<mat-dialog-content class="alert-dialog">
    <h4>You don't have any Teams created. Click here to set them up.</h4>
    <button mat-button class="go-btn" (click)="closeDialog()">Let's go!</button>
</mat-dialog-content>

